import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../features/components/Forms/StepForm/Step'
import Field from '../../../../../../components/Form/Field'

import { LONG_HEADLINE } from '../fields'

import useStyles from '../../../../../../styles/common/stepForms'

const stepFields = [LONG_HEADLINE]

function LongHeadlineStep({ formik, handleStepChange }) {
  const { t } = useTranslation()
  const commonClasses = useStyles()

  const { values } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields, values)
  }, [handleStepChange, values])

  return (
    <Step stepTitle="Add long headline" handleContinue={handleContinue}>
      <p className={commonClasses}>
        {t(
          'The long headline is the first line of your ad and appears instead of your short headline in larger ads. ' +
            'Long headlines can be up to 90 characters, and may appear with or without your description.'
        )}
      </p>
      <Field placeholder="Long Headline" name={LONG_HEADLINE} formik={formik} maxLength={90} />
    </Step>
  )
}

LongHeadlineStep.propTypes = {
  handleStepChange: PropTypes.func,
  formik: PropTypes.object
}

export default LongHeadlineStep
